import React from 'react';

/**
 * PiDiamondComponentSolid icon from the solid style in general category.
 */
interface PiDiamondComponentSolidProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  color?: string;
  className?: string;
  ariaLabel?: string;
}

export default function PiDiamondComponentSolid({
  size = 24,
  color,
  className,
  ariaLabel = 'diamond-component icon',
  ...props
}: PiDiamondComponentSolidProps): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      
       style={{color: color || "currentColor"}}
      
      role="img"
      aria-label={ariaLabel}
      {...props}
    >
      <path d="M12.773 1.49a2.5 2.5 0 0 0-1.546 0 2.5 2.5 0 0 0-.86.51c-.223.189-.47.436-.746.711l-.546.546c-.275.275-.522.523-.712.746a2.5 2.5 0 0 0-.508.86 2.5 2.5 0 0 0 0 1.545c.112.347.306.622.508.861.19.223.437.47.712.746l.546.546c.275.275.523.522.746.711.238.203.514.397.86.51a2.5 2.5 0 0 0 1.546 0c.346-.113.622-.307.86-.51.223-.189.47-.436.746-.711l.546-.546c.275-.276.522-.523.711-.746.203-.239.397-.514.51-.86a2.5 2.5 0 0 0 0-1.546 2.5 2.5 0 0 0-.51-.86c-.189-.223-.436-.47-.711-.746l-.546-.546A14 14 0 0 0 13.633 2a2.5 2.5 0 0 0-.86-.508Z" fill="currentColor"/><path d="M6.408 7.854a2.5 2.5 0 0 0-1.545 0 2.5 2.5 0 0 0-.86.51c-.223.188-.47.436-.746.711l-.546.546c-.275.275-.522.523-.712.746a2.5 2.5 0 0 0-.508.86 2.5 2.5 0 0 0 0 1.545c.112.347.306.622.508.86.19.224.437.471.712.746l.546.546c.275.276.523.523.746.712.238.203.514.396.86.51a2.5 2.5 0 0 0 1.545 0c.347-.114.622-.307.861-.51.223-.189.47-.436.746-.712l.546-.546c.275-.275.522-.522.711-.745.203-.239.397-.514.51-.86a2.5 2.5 0 0 0 0-1.546 2.5 2.5 0 0 0-.51-.86c-.189-.223-.436-.47-.711-.746l-.546-.546c-.276-.275-.523-.523-.746-.712a2.5 2.5 0 0 0-.86-.509Z" fill="currentColor"/><path d="M19.137 7.854a2.5 2.5 0 0 0-1.546 0 2.5 2.5 0 0 0-.86.51c-.223.188-.47.436-.746.711l-.546.546c-.275.275-.522.523-.712.746a2.5 2.5 0 0 0-.508.86 2.5 2.5 0 0 0 0 1.545c.112.347.306.622.508.86.19.224.437.471.712.746l.546.546c.275.276.523.523.746.712.238.203.514.396.86.51a2.5 2.5 0 0 0 1.546 0c.346-.114.622-.307.86-.51.223-.189.47-.436.746-.712l.546-.546c.275-.275.522-.522.711-.745.203-.239.397-.514.51-.86a2.5 2.5 0 0 0 0-1.546 2.5 2.5 0 0 0-.51-.86c-.189-.223-.436-.47-.711-.746l-.546-.546a14 14 0 0 0-.746-.712 2.5 2.5 0 0 0-.86-.509Z" fill="currentColor"/><path d="M12.773 14.219a2.5 2.5 0 0 0-1.546 0 2.5 2.5 0 0 0-.86.508c-.223.19-.47.437-.746.712l-.546.546c-.275.275-.522.523-.712.746a2.5 2.5 0 0 0-.508.86 2.5 2.5 0 0 0 0 1.546c.112.346.306.622.508.86.19.223.437.47.712.746l.546.546c.275.275.523.522.746.711.238.203.514.397.86.51a2.5 2.5 0 0 0 1.546 0c.346-.113.622-.307.86-.51.223-.189.47-.436.746-.711l.546-.546c.275-.275.522-.523.711-.746.203-.238.397-.514.51-.86a2.5 2.5 0 0 0 0-1.546 2.5 2.5 0 0 0-.51-.86c-.189-.223-.436-.47-.711-.746l-.546-.546a14 14 0 0 0-.746-.712 2.5 2.5 0 0 0-.86-.508Z" fill="currentColor"/>
    </svg>
  );
}
